export default {
    hostUrl: 'https://cg289vlvl4.execute-api.ap-south-1.amazonaws.com/Prod/' // --> Production
    // hostUrl: 'https://1hnzrdx911.execute-api.us-west-2.amazonaws.com/Prod/' // ---> develop
}